import * as Yup from 'yup'

export const getValidationSchema = () =>
  Yup.object().shape({
    availablePaths: Yup.string()
      .oneOf(['verified', 'not_verified'], 'Available path must be either "Verified" or "Not Verified"')
      .required('Available path is required'),
  })
